:host {
  min-height: 44px;
}
.dashboard__tab-button {
  min-height: 44px;
  display: flex;
  font-weight: 400;
  justify-content: end;
  cursor: pointer;
}

[dir="rtl"] .dashboard__tab-button {
  @extend .dashboard__tab-button;
  justify-content: start;
}
